import { AvailableServiceView, Service } from 'store/availableServices/types';
import { Building } from '../store/building/types';

export const getCurrentCurrency = (service: Service | AvailableServiceView, building: Building): string => {
  if ((!service && !building) || (!service?.currency && !building?.currency_type)) return 'USD';
  return service && service.currency ? service?.currency : building?.currency_type;
};
